module.exports = __webpack_public_path__ + "static/media/twitter-icon-2.1cb6b012.svg";